import {Collapse, FormControlLabel, Grid, Switch} from "@mui/material";
import {styled} from "@mui/material/styles";
import {Theme} from "@mui/system";
import InfoIcon from "@mui/icons-material/Info";

interface SearchBarContainerStylesProps {
  theme: Theme;
  showPac?: boolean;
}

export const SearchBarContainer = styled(Grid, {
  shouldForwardProp: propName => propName !== 'showPac'
})(({theme, showPac}: SearchBarContainerStylesProps) => ({
  borderRight: "0.07em solid #E0E0E0",
  boxShadow: showPac ? "0px 4px 4px rgba(0, 0, 0, 0.25);" : "none",
  width: "100%",
  [theme.breakpoints.down('lg')]: {
    borderRight: "none",
  },
}));

interface FilterOptionsContainerStylesProps {
  showAdminOnlyOptions?: boolean;
  hideFilterControls?: boolean;
}

export const FilterOptionsContainer = styled(Grid, {
  shouldForwardProp: propName => propName !== 'showAdminOnlyOptions' && propName !== 'hideFilterControls',
})(({hideFilterControls, showAdminOnlyOptions}: FilterOptionsContainerStylesProps) => ({
  flexDirection: 'row',
  backgroundColor: '#FBFBFF',
  flex: 1,
  gap: '1.8em',
  justifyContent: 'flex-start',
  padding: showAdminOnlyOptions ? '0em 1em' : '0em 3em',
  display: hideFilterControls ? 'none' : 'flex',
}));

export const FilterBox = styled(Grid)(() => ({
  width: 'fit-content',
  alignItems: 'center'
}));

export const PacInputWrapper = styled(Grid)(() => ({
  margin: "1em",
  width: "100%",
}));

export const FilterCollapse = styled(Collapse)(() => ({
  alignItems: 'center',
  justifyContent: 'space-between'
}));

export const ApprovalSwitch = styled(Switch)(() => ({
  marginLeft: '0.5em'
}));

export const SearchFormControlLabel = styled(FormControlLabel)(() => ({
  fontSize: '0.5em'
}));

export const SearchInfoIcon = styled(InfoIcon)(() => ({
  marginLeft: '-0.5em'
}));

